import React from 'react';

export default ({ name }) => {
  return <i className={`font-size-16 align-middle fas fa-${name}`}></i>;
};
